<template>
  <el-container class="container-basic">
    <el-aside :width="isCollapse ? '64px' : '230px'">
      <!-- 侧边栏Aside组件 -->
      <LayoutAside></LayoutAside>
    </el-aside>

    <el-container class="all-basic">
      <el-header>
        <!-- 控制显示和隐藏的按钮 -->
        <LayoutHeader></LayoutHeader>
      </el-header>
      <el-main class="main">
        <router-view class="router-view"></router-view>
      </el-main>
    </el-container>

    <!-- 小机器人 -->
    <img 
      src="../assets/robot.png" 
      alt="智能小助手" 
      class="robot" 
      @click="chatAssit" 
      @touchstart="enableDrag" 
      @contextmenu.prevent="showContextMenu($event)" 
    />

    <!-- 智能问答窗口 -->
    <div :class="['chat-window', chat ? 'active' : '']">
      <button 
        @click="chat = false" 
        class="close-btn"
      >
        ×
      </button>
      <Answer></Answer>
    </div>

    <!-- 右键菜单 -->
    <div v-if="showMenu" :style="{ top: `${menuPosition.y}px`, left: `${menuPosition.x}px` }" class="context-menu">
      <ul>
        <li @click="goToUpload">上传资源</li>
      </ul>
    </div>
  </el-container>
</template>
<script>
import LayoutAside from "./LayoutAside";
import LayoutHeader from "./LayoutHeader";
import { mapGetters } from "vuex";
import Answer from "@/components/Answer";

export default {
  components: { LayoutAside, LayoutHeader, Answer },
  computed: {
    ...mapGetters(["isCollapse"]),
  },
  data() {
    return {
      dialogVisible: false,
      chat: false,  // 初始状态为隐藏
      showMenu: false, // 控制右键菜单的显示
      menuPosition: { x: 0, y: 0 }, // 存储右键菜单的位置
    };
  },
  methods: {
    chatAssit() {
      this.chat = !this.chat;
      this.isWindowVisible = this.chat;
      const chatWindow = document.querySelector('.chat-window');
      if (this.chat) {
        chatWindow.classList.add('active');
      } else {
        chatWindow.classList.remove('active');
      }
      console.log("聊天窗口状态:", this.chat, "功能是否启用:", this.isWindowVisible);
    },
    enableDrag(event) {
      const robot = event.target;
      robot.style.position = "absolute";
      robot.ontouchmove = (e) => {
        const touch = e.touches[0];
        robot.style.left = `${touch.clientX - robot.offsetWidth / 2}px`;
        robot.style.top = `${touch.clientY - robot.offsetHeight / 2}px`;
      };
      robot.ontouchend = () => (robot.ontouchmove = null);
    },
    // 右键显示菜单
    showContextMenu(event) {
      this.menuPosition.x = event.clientX;
      this.menuPosition.y = event.clientY;
      this.showMenu = true;
    },
    // 点击上传资源跳转到对应页面
    goToUpload() {
      this.showMenu = false; // 隐藏右键菜单
      this.$router.push({ path: '/kgBase/index' }); // 跳转到上传资源页面
    },
  },
};
</script>
<style lang="less" scoped>
.container-basic {
  background-image: url('../assets/bg7.jpg');
  background-size: cover;
  width: 100%;
  height: 100%;
}
.el-header{
  height: 50px !important;
  padding: 0 !important;
}
.main {
  background-color: rgba(200, 201, 204, 0.454) !important;
}

/* 机器人样式 */
img.robot {
  position: absolute;
  bottom: 1vh;
  right: 1vw;
  width: 5vw;
  height: 10vh;
  z-index: 10;  /* 确保机器人在聊天窗口之上 */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: float 3s ease-in-out infinite;
}

img.robot:hover {
  transform: scale(1.2);
  // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

img.robot:active {
  transform: scale(0.9);
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* 问答窗口样式 */

.chat-window {
  display: none; /* 初始状态完全隐藏 */
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease-in-out;
  position: absolute;
  z-index: 100; /* 确保层级比其他元素高 */
  width: 25vw;
  height: 75%;
  background: rgba(106, 17, 203, 0.8);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  bottom: 12vh;
  right: 1vw;
  color: white;
  padding: 10px;
  pointer-events: none; /* 禁用交互 */
}

.chat-window.active {
  display: block; /* 激活时显示 */
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto; /* 激活时启用交互 */
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
}

/* 右键菜单样式 */
.context-menu {
  position: absolute;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  list-style: none;
  padding: 10px;
  width: 150px;
  z-index: 12;
}

.context-menu ul {
  margin: 0;
  padding: 0;
}

.context-menu li {
  padding: 8px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #f0f0f0;
}
.el-aside::-webkit-scrollbar {
  display: none; /* 针对 Webkit 内核的浏览器隐藏滚动条 */
}
</style>
